import React, { Fragment, useState, useEffect, useCallback } from "react";
import { makeStyles } from "@mui/styles";
import { Grid, Button, Typography } from "@mui/material";
import Profile from "./Chunks/Profile";
import VirtulaClasses from "./Chunks/VirtulaClasses";
import GradeBook from "./Chunks/GradeBook";
import Attendances from "./Chunks/Attendances";
import Exam from "./Chunks/Exam";
import GradedDiscussion from "./Chunks/GradedDiscussion";
import Assignements from "./Chunks/Assignements";
import LoginMenu from "../../../../components/LoginMenu/LoginMenu";
import CustomizedSnackbar from "../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import AnnouncementDialog from "../../../../components/AnnouncementDialog/AnnouncementDialog";
import AnnouncmentBackgroundIcon from "../../../../assets/Images/megaphoneIcon.png";
import StudentCourseSelectionAction from "./Chunks/StudentCourseSelectionAction";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    padding: 10,
  },
});

const HomePage = () => {
  const classes = useStyles();

  const [classesData, setClassesData] = useState([]);
  const [assignmentsData, setAssignmentsData] = useState([]);
  const [gradedDiscussionData, setGradedDiscussionData] = useState([]);
  const [coursesData, setCoursesData] = useState([]);
  const [attendancesData, setAttendancesData] = useState([]);
  const [examsData, setExamsData] = useState([]);
  const [feeAnouncementData, setFeeAnouncementData] = useState("");
  const [feeAnouncementOpen, setFeeAnouncementOpen] = useState(false);
  const [feeAnouncementLabel, setFeeAnouncementLabel] = useState("");
  const [feeAnouncementDate, setFeeAnouncementDate] = useState("");
  const [feeAnouncementDetails, setFeeAnouncementDetails] = useState("");
  const [feedbackAnouncementDetails, setFeedbackAnouncementDetails] = useState("");
  const [feedbackAnouncementLabel, setFeedbackAnouncementLabel] = useState("");
  const [feedbackAnouncementOpen, setFeedbackAnouncementOpen] = useState("");
  const [anouncementData, setAnouncementData] = useState([]);
  const [anouncementOpen, setAnouncementOpen] = useState(false);
  const [anouncementLabel, setAnouncementLabel] = useState("");
  const [anouncementDate, setAnouncementDate] = useState("");
  const [anouncementDetails, setAnouncementDetails] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoginMenu, setIsLoginMenu] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [admissionData, setAdmissionData] = useState([]);
  const [selectedCoursesData, setSelectedCoursesData] = useState([]);
  const [achivementsData, setAchivementsData] = useState([]);
  const [moduleData, setModuleData] = useState([]);
  const [isOpenActionMenu, setIsOpenActionMenu] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [viewLoading, setViewLoading] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [sessionData, setSessionData] = useState([]);
  const [programmeId, setProgrammeId] = useState("");
  const [programmeData, setProgrammeData] = useState([]);
  const [regStatusId, setRegStatusId] = useState(1);
  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState("");
  const [isDownloadExcel, setIsDownloadExcel] = useState(false);
  const [totalStudents, setTotalStudents] = useState([]);

  const handleFeeAnnouncmentDialog = useCallback(() => {
    const { feeDueDateStatus = 0, deactiveMessage = "" } =
      window.localStorage.getItem("lmsData")
        ? JSON.parse(window.localStorage.getItem("lmsData"))
        : {};
    setFeeAnouncementDate("");
    setFeeAnouncementDetails(deactiveMessage);
    setFeeAnouncementLabel("Fee Submission Notice");
    setFeeAnouncementOpen(true);
  }, []);

  const handleFeedbackAnnouncmentDialog = useCallback(() => {
    const { feedBackRequired = 0, feedBackMessage = "" } =
      window.localStorage.getItem("lmsData")
        ? JSON.parse(window.localStorage.getItem("lmsData"))
        : {};
    setFeedbackAnouncementDetails(feedBackMessage);
    setFeedbackAnouncementLabel("Feedback Submission Notice");
    setFeedbackAnouncementOpen(true);
  }, []);

  const handleAnnouncmentDialog = useCallback((anouncementData) => {
    if (anouncementData.length > 0) {
      setAnouncementDate(anouncementData[0].anouncementDate);
      setAnouncementDetails(anouncementData[0].anouncementDetails);
      setAnouncementLabel(anouncementData[0].label);
      setAnouncementOpen(anouncementData[0].anouncementDetails ? true : false);
    }
  }, []);

  const handleOpenSnackbar = useCallback((msg, severity) => {
    setIsOpenSnackbar(true);
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
  }, []);

  const handleCloseSnackbar = useCallback((event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setIsOpenSnackbar(false);
  }, []);

  const getClassesData = useCallback(async () => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C102CommonAcademicsTimeTableView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setClassesData(json.DATA || []);
          } else {
            handleOpenSnackbar(
              <span>
                {json.SYSTEM_MESSAGE}
                <br />
                {json.USER_MESSAGE}
              </span>,
              "error"
            );
          }
          console.log("TimeTableDataArray", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            console.log(error);
            handleOpenSnackbar(
              "Failed to fetch ! Please try Again later.",
              "error"
            );
          }
        }
      );
    setIsLoading(false);
  }, [handleOpenSnackbar]);

  const getAssignmentsData = useCallback(async () => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C107CommonAcademicsAssignmentsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setAssignmentsData(json.DATA || []);
          } else {
            handleOpenSnackbar(
              <span>
                {json.SYSTEM_MESSAGE}
                <br />
                {json.USER_MESSAGE}
              </span>,
              "error"
            );
          }
          console.log("getAssignmentsData", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            console.log(error);
            handleOpenSnackbar(
              "Failed to fetch ! Please try Again later.",
              "error"
            );
          }
        }
      );
    setIsLoading(false);
  }, [handleOpenSnackbar]);

  const getAttendancesData = useCallback(async () => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C108CommonAcademicsAttendanceStudentsLogView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setAttendancesData(json.DATA || []);
          } else {
            handleOpenSnackbar(
              <span>
                {json.SYSTEM_MESSAGE}
                <br />
                {json.USER_MESSAGE}
              </span>,
              "error"
            );
          }
          console.log("getAttendacesData", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            console.log(error);
            handleOpenSnackbar(
              "Failed to load attendances data.",
              "error"
            );
          }
        }
      );
    setIsLoading(false);
  }, [handleOpenSnackbar]);

  const getExamsData = useCallback(async () => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C113CommonAcademicsExamsDashboardView`;
    await fetch(url, {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            let data = json.DATA || [];
            let dataLength = data.length;
            setExamsData(data);
          } else {
            //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
            handleOpenSnackbar(
              <span>
                {json.SYSTEM_MESSAGE}
                <br />
                {json.USER_MESSAGE}
              </span>,
              "error"
            );
          }
          console.log("getExamsData", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            //alert('Failed to fetch, Please try again later.');
            handleOpenSnackbar(
              "Failed to fetch, Please try again later.",
              "error"
            );
            console.log(error);
          }
        }
      );
    setIsLoading(false);
  }, [handleOpenSnackbar]);

  const getGradedDiscussionData = useCallback(async () => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${
      process.env.REACT_APP_SUB_API_NAME
    }/lms/C106CommonAcademicsGradedDiscussionsBoardStudentsView?type=${0}`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            const data = json.DATA || [];
            const filterData = data.filter((item) => item.isUploaded === 0);
            if (filterData.length < 3) {
              filterData.push(...data);
            }
            setGradedDiscussionData(filterData);
          } else {
            handleOpenSnackbar(
              <span>
                {json.SYSTEM_MESSAGE}
                <br />
                {json.USER_MESSAGE}
              </span>,
              "error"
            );
          }
          console.log("getGradedDiscussionData", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            console.log(error);
            handleOpenSnackbar(
              "Failed to fetch ! Please try Again later.",
              "error"
            );
          }
        }
      );
    setIsLoading(false);
  }, [handleOpenSnackbar]);

  const getCoursesData = useCallback(async () => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C103CommonAcademicsCoursesStudentsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setCoursesData(json.DATA || []);
          } else {
            handleOpenSnackbar(
              json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE,
              "error"
            );
          }
          console.log("TimeTableDataArray", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            console.log(error);
            handleOpenSnackbar(
              "Failed to fetch ! Please try Again later.",
              "error"
            );
          }
        }
      );
    setIsLoading(false);
  }, [handleOpenSnackbar]);

  const getAnnoucementsData = useCallback(async () => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C109CommonAcademicsAnouncementsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            const data = json.DATA || [];
            setAnouncementData(data);
            // if (localStorage.getItem("lmsAnnouncementReadFlag") != 1)
            handleAnnouncmentDialog(data);
          } else {
            handleOpenSnackbar(
              json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE,
              "error"
            );
          }
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            console.log(error);
            handleOpenSnackbar(
              "Failed to load annoucments data ! Please try Again later.",
              "error"
            );
          }
        }
      );
    setIsLoading(false);
  }, [handleOpenSnackbar, handleAnnouncmentDialog]);

  const onSetMeetingConfig = useCallback((data = {}) => {
    const { email = "", displayName = "" } = window.localStorage.getItem(
      "lmsData"
    )
      ? JSON.parse(window.localStorage.getItem("lmsData"))
      : {};
    const studentId = localStorage.getItem("lmsStudentId") || "N/A";
    const meetingConfig = {
      meetingNumber: data.meetingId,
      leaveUrl: process.env.REACT_APP_LMS_URL,
      userName: `${studentId} - ${displayName}`,
      userEmail: email,
      password: data.meetingPassword,
      role: 0,
      courseName: data.courseLabel,
      classObject: data,
    };
    localStorage.setItem("lmsMeetingConfig", JSON.stringify(meetingConfig));
    window.location.href = process.env.REACT_APP_LMS_ZOOM_URL;
  }, []);

  const downloadFile = useCallback((e, fileName) => {
    e.preventDefault();
    const data = new FormData();
    data.append("fileName", fileName);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${
      process.env.REACT_APP_SUB_API_NAME
    }/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.blob();
        } else if (res.status === 401) {
          setIsLoginMenu(true);
          setIsReload(false);
          return {};
        } else {
          alert("Operation Failed, Please try again later.");
          return {};
        }
      })
      .then((result) => {
        var csvURL = window.URL.createObjectURL(result);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        console.log(csvURL);
        if (result.CODE === 1) {
          //Code
        } else if (result.CODE === 2) {
          alert(
            "SQL Error (" +
              result.CODE +
              "): " +
              result.USER_MESSAGE +
              "\n" +
              result.SYSTEM_MESSAGE
          );
        } else if (result.CODE === 3) {
          alert(
            "Other Error (" +
              result.CODE +
              "): " +
              result.USER_MESSAGE +
              "\n" +
              result.SYSTEM_MESSAGE
          );
        } else if (result.error === 1) {
          alert(result.error_message);
        } else if (result.success === 0 && result.redirect_url !== "") {
          window.location = result.redirect_url;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const onJoinClick = useCallback(async (e, data = {}) => {
    e.preventDefault();
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${
      process.env.REACT_APP_SUB_API_NAME
    }/lms/C104CommonAcademicsAttendanceStudentsLogSave?classId=${
      data.id
    }&typeId=${1}`;
    await fetch(url, {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            onSetMeetingConfig(data);
          } else {
            alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
          }
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(false);
          } else {
            alert("Operation Faild ! Please try again");
          }
        }
      );
    setIsLoading(false);
  }, [onSetMeetingConfig]);

  const onFeeAnnouncementClose = useCallback(() => {
    sessionStorage.setItem("lmsFeeAnnouncementReadFlag", 1);
    setFeeAnouncementOpen(false);
    setFeeAnouncementDetails("");
    setFeeAnouncementDate("");
    setFeeAnouncementLabel("");
  }, []);

  const onFeedbackAnnouncementClose = useCallback(() => {
    sessionStorage.setItem("lmsFeedbackAnnouncementReadFlag", 1);
    setFeedbackAnouncementOpen(false);
    setFeedbackAnouncementDetails("");
    setFeedbackAnouncementLabel("");
  }, []);

  const getCouresData = useCallback(async (rowData) => {
    setViewLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C117CommonAcademicsSessionsOfferedCoursesView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            let coursesData = json.DATA || [];
            let selectedCoursesData = [];
            for (let i = 0; i < coursesData.length; i++) {
              if (coursesData[i].isRegistered) {
                selectedCoursesData.push(coursesData[i]);
              }
            }
            setCoursesData(json.DATA || []);
            setIsOpenActionMenu(true);
            setSelectedData(rowData);
            setSelectedCoursesData(selectedCoursesData);
          } else {
            alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
          }
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            alert("Failed to fetch, Please try again later.");
            console.log(error);
          }
        }
      );
    setViewLoading(false);
  }, []);

  const getModulesData = useCallback(async (rowData) => {
    setViewLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C117CommonProgrammeModulesView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            for (var i = 0; i < json.DATA.length; i++) {
              let achivedCoursesArray =
                json.DATA[i].isAchievedCoursesArray.split(",");
              let coursesArray = json.DATA[i].courses.split(",");
              let courses = coursesArray.map((data, index) => (
                <Fragment key={"pmc" + data + index}>
                  {achivedCoursesArray.indexOf(data) !== -1 ? (
                    <span
                      style={{
                        color: "#4caf50",
                      }}
                    >
                      {data}
                    </span>
                  ) : (
                    data
                  )}
                  <br />
                </Fragment>
              ));
              json.DATA[i].courses = <div>{courses}</div>;
            }
            setModuleData(json.DATA || []);
          } else {
            alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
          }
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            alert("Failed to fetch, Please try again later.");
            console.log(error);
          }
        }
      );
    setViewLoading(false);
  }, []);

  const getStudentAchivementsData = useCallback(async (rowData) => {
    setViewLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C117CommonAcademicsCoursesStudentsAchievementsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setAchivementsData(json.DATA || []);
          } else {
            alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
          }
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            alert("Failed to fetch, Please try again later.");
            console.log(error);
          }
        }
      );
    setViewLoading(false);
  }, []);

  const getProgrammeData = useCallback(async (id) => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C22CommonAcademicsSessionsOfferedProgrammesView?sessionId=${id}`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setProgrammeData(json.DATA || []);
          } else {
            alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
          }
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            alert("Failed to fetch, Please try again later.");
            console.log(error);
          }
        }
      );
  }, []);

  const onClearFilters = useCallback(() => {
    setRegStatusId(1);
    setStudentId("");
    setStudentName("");
  }, []);

  const onSaveClick = useCallback(() => {
    document.getElementById("courseSubmit").click();
  }, []);

  const onFormSubmit = useCallback(async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData(e.target);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C117CommonAcademicsCoursesStudentsSave`;
    await fetch(url, {
      method: "POST",
      body: formData,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            alert("Saved");
            // this.getData();
            setReadOnly(false);
            setIsOpenActionMenu(false);
          } else {
            alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
          }
          console.log(json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(false);
          } else {
            alert("Failed to Save, Please try again later.");
            console.log(error);
          }
        }
      );
    setIsLoading(false);
  }, []);

  // getData = async (isChangeCall = false, value = "") => {
  //   this.setState({
  //     isLoading: true,
  //   });
  //   const programmeId = isChangeCall ? value : this.state.programmeId;
  //   const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C22CommonStudentsView?sessionId=${this.state.sessionId}&statusId=${this.state.regStatusId}&programmeGroupId=${programmeId}&studentId=${this.state.studentId}&studentName=${this.state.studentName}`;
  //   await fetch(url, {
  //     method: "GET",
  //     headers: new Headers({
  //       Authorization: "Bearer " + localStorage.getItem("lmsToken"),
  //     }),
  //   })
  //     .then((res) => {
  //       if (!res.ok) {
  //         throw res;
  //       }
  //       return res.json();
  //     })
  //     .then(
  //       (json) => {
  //         if (json.CODE === 1) {
  //           this.setState({
  //             admissionData: json.DATA || [],
  //           });
  //           let totalStudents = this.state.admissionData.length;
  //           this.setState({totalStudents: totalStudents});
  //         } else {
  //           alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
  //         }
  //         console.log(json);
  //       },
  //       (error) => {
  //         if (error.status === 401) {
  //           this.setState({
  //             isLoginMenu: true,
  //             isReload: false,
  //           });
  //         } else {
  //           alert("Failed to fetch, Please try again later.");
  //           console.log(error);
  //         }
  //       }
  //     );
  //   this.setState({
  //     isLoading: false,
  //   });
  // };

  const onAnnouncementClose = useCallback(() => {
    // const myData = window.localStorage.getItem("lmsData")
    //   ? JSON.parse(window.localStorage.getItem("lmsData"))
    //   : {};
    // myData.anouncementDate = "";
    // myData.anouncementLabel = "";
    // myData.anouncementDetails = "";
    // window.localStorage.setItem("lmsData", JSON.stringify(myData));
    window.localStorage.setItem("lmsAnnouncementReadFlag", 1);
    setAnouncementOpen(false);
    setAnouncementDetails("");
    setAnouncementDate("");
    setAnouncementLabel("");
  }, []);

  const onAnnouncementClick = useCallback((anouncment) => {
    setAnouncementOpen(true);
    setAnouncementDetails(anouncment.anouncementDetails);
    setAnouncementDate(anouncment.anouncementDate);
    setAnouncementLabel(anouncment.label);
  }, []);

  const handleSetCourses = useCallback((value = []) => {
    for (let i = 0; i < value.length; i++) {
      value[i].isRegistered = 1;
    }
    setSelectedCoursesData(value);
  }, []);

  const handleCheckboxChange = useCallback((e, value = {}, type = 0) => {
    const { checked } = e.target;
    const { id } = value;
    setCoursesData((prevCoursesData) => {
      const coursesData = [...prevCoursesData];
      const index = coursesData.findIndex((item) => item.id === id);
      if (index >= 0) {
        if (type === 0) {
          coursesData[index].isRegistered = checked ? 1 : 0;
          coursesData[index].isRepeat = 0;
        } else {
          coursesData[index].isRepeat = checked ? 1 : 0;
        }
      }
      return coursesData;
    });
  }, []);

  const onCheckClear = useCallback(() => {
    setCoursesData((prevCoursesData) => {
      const coursesData = [...prevCoursesData];
      for (let i = 0; i < coursesData.length; i++) {
        coursesData[i].isRegistered = 0;
        coursesData[i].isRepeat = 0;
      }
      return coursesData;
    });
  }, []);

  useEffect(() => {
    getClassesData();
    getAssignmentsData();
    getCoursesData();
    getExamsData();
    getGradedDiscussionData();
    getAttendancesData();
    getAnnoucementsData();
    const { feedBackRequired = 0, feeDueDateStatus = 0 } =
      window.localStorage.getItem("lmsData")
        ? JSON.parse(window.localStorage.getItem("lmsData"))
        : {};
    if (
      feedBackRequired != 0 &&
      sessionStorage.getItem("lmsFeedbackAnnouncementReadFlag") != 1
    ) {
      handleFeedbackAnnouncmentDialog();
    }
    if (
      feeDueDateStatus != 0 &&
      sessionStorage.getItem("lmsFeeAnnouncementReadFlag") != 1
    ) {
      console.log("Data is coming");
      handleFeeAnnouncmentDialog();
    }
  }, [
    getClassesData,
    getAssignmentsData,
    getCoursesData,
    getExamsData,
    getGradedDiscussionData,
    getAttendancesData,
    getAnnoucementsData,
    handleFeedbackAnnouncmentDialog,
    handleFeeAnnouncmentDialog,
  ]);

  return (
    <Fragment>
      {/*
        <ControlledDialog handleClose={() => onAnnouncementClose()} dividers open={anouncementOpen} title="Announcment" content={
          <Fragment>
              <div>
                  <b>{anouncementLabel}</b>
                  <span style={{
                      color: 'grey',
                      float: 'right',
                      fontSize: 14
                  }}>{anouncementDate}</span>
                  <br />
                  {anouncementDetails}
              </div>
          </Fragment>
          } actions={
              <Button onClick={() => onAnnouncementClose()}>
                  Close
              </Button>
          }
        />
        */}
      <AnnouncementDialog
        handleClose={() => onFeeAnnouncementClose()}
        dividers
        open={feeAnouncementOpen}
        titleStyle={{ backgroundColor: "#b22c2c" }}
        title="Notification"
        content={
          <Fragment>
            <span style={{ float: "right" }}>
              <span style={{ color: "grey", float: "right", fontSize: 14 }}>
                {feeAnouncementDate}
              </span>
              <br />
              <img
                src={AnnouncmentBackgroundIcon}
                style={{
                  height: 80,
                  paddingRight: 12,
                  float: "right",
                  marginTop: 7,
                }}
              />
            </span>
            <span>
              <Typography color="primary" component="span" variant="h5">
                {feeAnouncementLabel}
              </Typography>
              <br />
              <Typography variant="body1" component="span">
                &emsp;{feeAnouncementDetails}
              </Typography>
            </span>
          </Fragment>
        }
        actions={
          <Button
            color="primary"
            variant="contained"
            onClick={() =>
              window.location.replace("#/dashboard/TutionFeePayment/0")
            }
          >
            Pay Now
          </Button>
        }
      />
      <AnnouncementDialog
        handleClose={() => onFeedbackAnnouncementClose()}
        dividers
        open={feedbackAnouncementOpen}
        title="Notification"
        content={
          <Fragment>
            <span style={{ float: "right" }}>
              <br />
              <img
                src={AnnouncmentBackgroundIcon}
                style={{
                  height: 80,
                  paddingRight: 12,
                  float: "right",
                  marginTop: 7,
                }}
              />
            </span>
            <span>
              <Typography color="primary" component="span" variant="h5">
                {feedbackAnouncementLabel}
              </Typography>
              <br />
              <Typography variant="body1" component="span">
                &emsp;{feedbackAnouncementDetails}
              </Typography>
            </span>
          </Fragment>
        }
        actions={
          <Button
            color="primary"
            variant="contained"
            onClick={() => window.location.replace("#/dashboard/F115Form/0")}
          >
            Submit Now
          </Button>
        }
      />
      <AnnouncementDialog
        handleClose={() => onAnnouncementClose()}
        dividers
        open={anouncementOpen}
        title="Announcement"
        content={
          <Fragment>
            <span style={{ float: "right" }}>
              <span style={{ color: "grey", float: "right", fontSize: 14 }}>
                {anouncementDate}
              </span>
              <br />
              <img
                src={AnnouncmentBackgroundIcon}
                style={{
                  height: 80,
                  paddingRight: 12,
                  float: "right",
                  marginTop: 7,
                }}
              />
            </span>
            <span>
              <Typography color="primary" component="span" variant="h5">
                {anouncementLabel}
              </Typography>
              <br />
              <Typography variant="body1" component="span">
                &emsp;{anouncementDetails}
              </Typography>
            </span>
          </Fragment>
        }
        actions={
          <Button
            color="secondary"
            onClick={() => onAnnouncementClose()}
          >
            Close
          </Button>
        }
      />
      <LoginMenu
        reload={isReload}
        open={isLoginMenu}
        handleClose={() => setIsLoginMenu(false)}
      />
      <StudentCourseSelectionAction
        onSave={() => onSaveClick()}
        open={isOpenActionMenu}
        handleClose={() => {
          setIsOpenActionMenu(false);
          setReadOnly(false);
        }}
        selectedData={selectedData}
        coursesData={coursesData}
        moduleData={moduleData}
        achivementsData={achivementsData}
        onClear={() => onCheckClear()}
        handleCheckboxChange={(e, value, type) =>
          handleCheckboxChange(e, value, type)
        }
        selectedCoursesData={selectedCoursesData}
        handleSetCourses={(value) => handleSetCourses(value)}
        readOnly={readOnly}
      />
      <form noValidate id="selectionForm" onSubmit={onFormSubmit}>
        {selectedCoursesData.map((item, i) => {
          if (item.isRegistered === 1) {
            return (
              <Fragment key={"coursesData" + i + item}>
                <input name="courseId" value={item.id} type="hidden" />
                <input
                  name="isRepeat"
                  value={item.isRepeat || 0}
                  type="hidden"
                />
              </Fragment>
            );
          }
        })}
        <input type="submit" style={{ display: "none" }} id="courseSubmit" />
      </form>
      <CustomizedSnackbar
        isOpen={isOpenSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity}
        handleCloseSnackbar={() => handleCloseSnackbar()}
      />
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 3 }} container>
            <Grid size={12}>
              <Profile
                anouncementData={anouncementData}
                onAnnouncementClick={(data) => onAnnouncementClick(data)}
                onFeeAnnouncementClick={() => handleFeeAnnouncmentDialog()}
                coursesData={coursesData}
                getCouresData={() => getCouresData()}
                backendData={{ DATA: attendancesData }}
              />
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, sm: 9 }} container spacing={2}>
            <Grid size={{ xs: 12, sm: 4 }}>
              <VirtulaClasses
                onJoinClick={(e, data) => onJoinClick(e, data)}
                classesData={classesData}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Attendances
                data={attendancesData}
                isLoading={isLoading}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Assignements
                data={assignmentsData}
                isLoading={isLoading}
                downloadFile={(e, fileName) => downloadFile(e, fileName)}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <GradeBook />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Exam
                data={examsData}
                isLoading={isLoading}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <GradedDiscussion
                data={gradedDiscussionData}
                isLoading={isLoading}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

export default HomePage;
